import { Navigate, Route, Routes } from "react-router-dom";
import { GuardRoute } from "@/components/GuardRoute";
import LoginPage from "@/pages/Auth/login";
import LogsPage from "@/pages/logs/page";
import OrganizationsPage from "./pages/organizations/page";
import FeedbackPage from "./pages/feedback/page";
import SystemMessagesPage from "./pages/system-messages/page";
import OrganizationDetailPage from "./pages/organization-detail/page";
import PricingPage from "./pages/pricing/page";
import PackagesPage from "./pages/packages/page";

const App = () => (
  <Routes>
    <Route path="/auth/login" element={<LoginPage />} />
    <Route path="/auth/signin" element={<LoginPage />} />
    <Route element={<GuardRoute />}>
      <Route path="/" element={<Navigate to="/logs" />} />
      <Route path="/logs" element={<LogsPage />} />
      <Route path="/organizations" element={<OrganizationsPage />} />
      <Route path="/organizations/:organizationId" element={<OrganizationDetailPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/packages" element={<PackagesPage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/system-messages" element={<SystemMessagesPage />} />
    </Route>
  </Routes>
);

export default App;
